import { render, staticRenderFns } from "./FormStep.vue?vue&type=template&id=251b843d&scoped=true&"
import script from "./FormStep.vue?vue&type=script&lang=js&"
export * from "./FormStep.vue?vue&type=script&lang=js&"
import style0 from "./FormStep.vue?vue&type=style&index=0&id=251b843d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251b843d",
  null
  
)

export default component.exports